import { Box, Divider, Grid, IconButton, SxProps, Theme } from '@mui/material';
import Typography from '@mui/material/Typography';

import { ReactComponent as CloseIcon } from '@/assets/svg/close.svg';
import type { Variant } from '@mui/material/styles/createTypography';

type Props = {
  pl?: string;
  pr?: string;
  variant?: Variant;
  sx?: SxProps<Theme>;
  title: string;
  onClose: (() => void) | undefined;
  divider?: boolean;
};

export const Header = (props: Props) => {
  return (
    <Grid container direction='column'>
      <Box pl={props.pl ?? '32px'} pr={props.pr ?? '27px'}>
        <Grid container item direction='row' justifyContent='space-between'>
          <Typography pt='18px' pb='19px' variant={props.variant ?? 'h3'} sx={props.sx}>
            {props.title}
          </Typography>
          <Box pt='8px' pb='8px'>
            <IconButton onClick={props.onClose} style={{ borderRadius: 0 }}>
              <CloseIcon />
            </IconButton>
          </Box>
        </Grid>
      </Box>
      {(props.divider ?? true) && <Divider />}
    </Grid>
  );
};
